
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/connectors/[[...slug]]",
      function () {
        return require("private-next-pages/settings/connectors/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/connectors/[[...slug]]"])
      });
    }
  